import SearchIcon from 'components/shared/searchIcon';
import BackChevron from 'components/shared/back-chevron';
import Icon from 'components/shared/icon';
import { useSalonSearch } from 'hooks';
import { useGlobalModules } from 'contexts';
import SlidePanel from '../../slidePanel/slidePanel';
import styles from './salonPanel.module.scss';

export default function SalonPanel({ isOpen, onClose, onCloseDrawer, locale }) {
  const globalModules = useGlobalModules();
  const { salonSelector } = globalModules?.translations;

  const {
    filteredSalons,
    searchQuery,
    setSearchQuery,
    selectedSalon,
    setSelectedSalon,
    loading,
    confirmSelection,
    showingNearest,
  } = useSalonSearch({ locale, isOpen });

  return (
    <SlidePanel
      isOpen={isOpen}
      nested
      onClose={onClose}
      ariaLabel={salonSelector?.selectAmbassadorSalon}
    >
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <button type="button" className={styles.backBtn} onClick={onClose} aria-label="Back">
            <BackChevron width={16} height={16} />
            <span className={styles.title}>{salonSelector?.selectAmbassadorSalon}</span>
          </button>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onCloseDrawer}
            aria-label={globalModules?.translations?.accessibility?.closeCart || 'Close'}
          >
            <Icon type="close" />
          </button>
        </div>
        <p className={styles.description}>{salonSelector?.salonChoiceDescription}</p>
      </div>
      <div className={styles.searchBarWrapper}>
        <SearchIcon />
        <input
          className={styles.searchBar}
          type="text"
          value={searchQuery}
          placeholder={salonSelector?.searchPlaceholder}
          onChange={e => setSearchQuery(e.target.value)}
        />
      </div>
      <div className={styles.optionsView}>
        {loading && <Icon className={styles.loadingIcon} type="loading" />}
        {!loading && showingNearest && salonSelector?.showingNearestSalons && (
          <p className={styles.nearestHint}>{salonSelector.showingNearestSalons}</p>
        )}
        {!loading &&
          filteredSalons.map(salon => (
            <div
              key={salon.salonNo}
              className={styles.salonOption}
              tabIndex={0}
              role="option"
              aria-selected={selectedSalon?.salonName === salon.salonName}
              onClick={() => setSelectedSalon(salon)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') setSelectedSalon(salon);
              }}
            >
              <input
                className={styles.salonRadio}
                type="radio"
                tabIndex={-1}
                checked={selectedSalon?.salonName === salon.salonName}
                onChange={() => {}}
              />
              <div className={styles.salonInfo}>
                <p className={styles.salonName}>
                  {salon.formattedDistance ? `${salon.formattedDistance} KM - ` : ''}
                  {salon.salonName}
                </p>
                {(salon.AddressLine2 || salon.city) && (
                  <p className={styles.salonAddress}>
                    {[salon.AddressLine2, salon.city].filter(Boolean).join(', ')}
                  </p>
                )}
              </div>
            </div>
          ))}
      </div>
      <div className={styles.footer}>
        <button
          className={styles.confirmChoice}
          type="button"
          onClick={() => confirmSelection(() => onClose())}
        >
          {salonSelector?.confirmChoice}
        </button>
      </div>
    </SlidePanel>
  );
}
